// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f0ad607b","732":"2ad43e2f","977":"7d160783"}[chunkId] + ".chunk.js";
};